<template>
  <div class="flex flex-wrap justify-center sm:justify-start">
    <div
      v-for="reaction in reactions"
      :key="reaction.value"
      class="tooltip mb-2 mr-2 flex cursor-pointer items-center justify-center rounded-lg px-2 py-1 last:mr-0 sm:px-4"
      :class="[
        localIsReactions?.includes(reaction.value)
          ? 'bg-black-100'
          : 'bg-[#F5F5F5]',
      ]"
      @click="handleReaction(reaction.value)"
    >
      <div class="size-6 min-w-[24px]">
        <img v-lazy-load :src="reaction.src" alt="" class="object-cover" />
      </div>
      <div
        class="ml-2 text-[14px] font-medium leading-4 empty:ml-0"
        :class="{
          'text-white-100': localIsReactions?.includes(reaction.value),
        }"
      >
        {{ articleReactions[reaction.value] + reaction.localVote || '' }}
      </div>

      <span class="tooltiptext">{{ reaction.text }}</span>
    </div>
  </div>
</template>

<script setup>
import api from '@/services/api/api';

const props = defineProps({
  articleId: {
    type: String,
    default: null,
  },
  articleReactions: {
    type: Object,
    default: () => ({}),
  },
});

const reactions = [
  {
    text: 'Мне нравится',
    src: '/reactions/thumbs.png',
    value: 'reaction_like',
    localVote: 0,
  },
  {
    text: 'Надо подумать',
    src: '/reactions/thinkface.png',
    value: 'reaction_think',
    localVote: 0,
  },
  {
    text: 'Тема для дискуссии',
    src: '/reactions/boxing.png',
    value: 'reaction_discussion',
    localVote: 0,
  },
  {
    text: 'Это неожиданно!',
    src: '/reactions/facemouth.png',
    value: 'reaction_suddenly',
    localVote: 0,
  },
  {
    text: 'Материал – огонь!',
    src: '/reactions/fire.png',
    value: 'reaction_fire',
    localVote: 0,
  },
  {
    text: 'Мне не нравится',
    src: '/reactions/dont_like.png',
    value: 'reaction_dont_like',
    localVote: 0,
  },
];

const userReactionString = ref(null);
const userReactions = ref({});
const localIsReactions = ref([]);

onMounted(() => {
  userReactionString.value = localStorage.getItem('reactions');
  userReactions.value = JSON.parse(userReactionString.value) || {};
  localIsReactions.value =
    props.articleId in userReactions.value
      ? userReactions.value[props.articleId]
      : [];
});

const handleReaction = async (value) => {
  const like = async () => {
    try {
      await api.socials.handleSetReaction({
        id: props.articleId,
        reaction: value,
      });

      reactions.find((r) => r.value === value).localVote++;

      if (!userReactionString.value) {
        userReactions.value = { [props.articleId]: [value] };
      } else if (!(props.articleId in userReactions.value)) {
        userReactions.value[props.articleId] = [value];
      } else if (
        props.articleId in userReactions.value &&
        !userReactions.value[props.articleId].includes(value)
      ) {
        userReactions.value[props.articleId].push(value);
      }

      localStorage.setItem('reactions', JSON.stringify(userReactions.value));
      localIsReactions.value = userReactions.value[props.articleId];
    } catch (e) {
      console.log(e);
    }
  };

  const dislike = async () => {
    try {
      await api.socials.handleUnsetReaction({
        id: props.articleId,
        reaction: value,
      });

      reactions.find((r) => r.value === value).localVote--;

      if (localIsReactions.value.includes(value)) {
        userReactions.value[props.articleId] = localIsReactions.value.filter(
          (reaction) => reaction !== value,
        );
        localStorage.setItem('reactions', JSON.stringify(userReactions.value));
        localIsReactions.value = userReactions.value[props.articleId];
      }
    } catch (e) {
      console.log(e);
    }
  };

  localIsReactions.value.includes(value) ? await dislike() : await like();
};
</script>
